
import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface TermsCheckboxProps {
  agreeTerms: boolean;
  setAgreeTerms: (agreed: boolean) => void;
}

const TermsCheckbox = ({ agreeTerms, setAgreeTerms }: TermsCheckboxProps) => {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id="terms"
        checked={agreeTerms}
        onCheckedChange={(checked) => setAgreeTerms(!!checked)}
        required
      />
      <Label htmlFor="terms" className="text-sm font-normal">
        I agree to the{" "}
        <Link 
          to="/terms-and-conditions" 
          className="text-godyspo-blue hover:text-godyspo-blue/90 underline-offset-4 hover:underline"
        >
          Terms & Conditions
        </Link>{" "}
        and{" "}
        <Link 
          to="/privacy-policy" 
          className="text-godyspo-blue hover:text-godyspo-blue/90 underline-offset-4 hover:underline"
        >
          Privacy Policy
        </Link>
      </Label>
    </div>
  );
};

export default TermsCheckbox;
